<template>
  <span>
    <el-tooltip
      class="item"
      effect="light"
      :content="toolTipContent"
      placement="bottom"
      :visible-arrow="finalShareDisabled"
      v-if="hasPermission('Manage media_Create')"
    >
      <span>
        <el-button
          type="text"
          class="icon-button"
          :class="{ disabled: finalShareDisabled }"
          :disabled="finalShareDisabled"
          @click="handleShare"
          ><i class="el-icon-share"></i
        ></el-button>
      </span>
    </el-tooltip>

    <BaseFormDialog3
      v-model="visible"
      :title="title"
      :data="formDataList"
      @submit="handleSubmit"
      :submitBtnTxt="btnTxt"
      :renderPass="cansub"
      textReminder=""
    >
      <template slot="renderHtml" slot-scope="scope">
        <gg-input
          v-if="scope.data.key === 'caption'"
          :key="scope.data.key"
          :ref="scope.data.key"
          :placeholder="scope.data.placeholder"
          v-model="caption"
          :error="errorObj"
        />
      </template>
    </BaseFormDialog3>
    <Snackbar :visible.sync="snackbarData.visible" :content="snackbarData.content" />
  </span>
</template>
<script>
import { hasPermission } from './../utils/utils.js'
import { Ajax } from '@/common'
import { mapState } from 'vuex'
import SvgIcon from '@/components/SvgIcon'
import bus from '../utils/bus'
export default {
  components: { SvgIcon },
  props: {
    list: {
      default: () => [],
      type: Array
    },
    classId: {
      default: '',
      type: String
    },
    maxPhotoShareCount: {
      default: 10,
      type: Number
    },
    maxVideoShareCount: {
      default: 1,
      type: Number
    },
    photoLimitMessage: {
      default: '',
      type: String
    },
    videoLimitMessage: {
      default: '',
      type: String
    },
    forceDisabled: {
      default: false,
      type: Boolean
    },
    forceDisabledMessage: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      title: 'Add a caption',
      btnTxt: 'Next',
      visible: false,
      loading: false,
      cansub: true,
      formDataList: [
        {
          placeholder: 'Caption',
          key: 'caption',
          value: '',
          renderHtml: true
        }
      ],
      caption: '',
      currentCaption: '',
      errorObj: {
        show: false,
        message: ''
      },
      snackbarData: {
        visible: false,
        content: ''
      },
      isDirectShare: false
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    }),
    selectedMediaType() {
      if (this.list.length === 0) {
        return null
      }
      return this.list[0].mediaType
    },
    selectedMediaWord() {
      return this.selectedMediaType == 1 ? 'video' : 'photo'
    },
    selectedMediaWordPlural() {
      return this.selectedMediaType == 1 ? 'videos' : 'photos'
    },
    shareLimitExceeded() {
      if (this.list.length === 0 || this.selectedMediaType === null) {
        return false
      }
      if (this.selectedMediaType == 1) {
        return this.list.length > this.maxVideoShareCount
      }
      return this.list.length > this.maxPhotoShareCount
    },
    shareDisabled() {
      return this.shareLimitExceeded
    },
    finalShareDisabled() {
      return this.forceDisabled || this.shareDisabled
    },
    toolTipContent() {
      if (this.list.length == 0) {
        return 'No photos selected'
      } else if (this.forceDisabled) {
        return this.forceDisabledMessage || 'Share'
      } else if (this.shareLimitExceeded) {
        if (this.selectedMediaType == 1) {
          return this.videoLimitMessage || 'You can only share one video at a time'
        }
        return this.photoLimitMessage || `Cannot share more than ${this.maxPhotoShareCount} photos`
      } else {
        return 'Share'
      }
    }
  },
  watch: {
    caption(newVal, oldVal) {
      this.formDataList[0].value = newVal
      if (newVal.length <= 80) {
        this.cansub = true
        this.errorObj = {
          show: false,
          message: ''
        }
      } else {
        this.cansub = false
        this.errorObj = {
          show: true,
          message: 'Character limit of 80'
        }
      }
    }
  },
  methods: {
    hasPermission,
    handleShare() {
      if (this.finalShareDisabled) {
        return
      }
      this.caption = ''
      this.currentCaption = ''
      this.formDataList[0].value = ''
      this.cansub = true
      this.errorObj = {
        show: false,
        message: ''
      }
      this.isDirectShare = hasPermission('Share media_Full')
      this.visible = true
    },
    handleSubmit() {
      let formData = {}
      this.formDataList.forEach((item) => {
        formData[item.key] = item.value
      })
      this.visible = false
      this.goNext()
    },
    goNext() {
      const confirmText = this.isDirectShare
        ? `Once submitted, the ${this.selectedMediaWordPlural} will be directly shared and viewed by parents. `
        : `Once submitted, the ${this.selectedMediaWordPlural} will be sent for approval before being shared and viewed by parents. `
      const confirmBtnText = this.isDirectShare ? 'Share' : 'Submit'
      this.$confirm(confirmText, `Share ${this.selectedMediaWord}?`, {
        cancelButtonText: 'Cancel',
        confirmButtonText: confirmBtnText,
        cancelButtonClass: 'gg_cancel_button',
        confirmButtonClass: 'gg_submit_button',
        customClass: 'gg_confirm',
        showClose: false
      })
        .then(() => {
          if (this.isDirectShare) {
            // Direct share - use shareAndApproveBatch
            const _items = this.list.map((o) => {
              return {
                mediaId: o.id,
                caption: this.caption || ' ',
                shareByTeacher: this.user.userId,
                fileDisplayName: o.fileDisplayName,
                mediaImagePath: o.mediaType === 1 ? o.imagePath : null
              }
            })
            const params = {
              items: _items,
              classId: this.classId,
              approvalUser: this.user.userId
            }
            Ajax.post('/moments/share/shareAndApproveBatch', params).then((res) => {
              if (res.code == '0000') {
                bus.$emit('refreshImageList')
                this.$emit('ok')
              } else {
                this.handleSnack(res.message)
              }
            })
          } else {
            // Normal share - use shareBatch
            const _arr = this.list.map((o) => {
              return {
                mediaId: o.id,
                caption: this.caption || ' ',
                shareByTeacher: this.user.userId,
                fileDisplayName: o.fileDisplayName
              }
            })
            console.log(_arr)
            Ajax.post('/moments/share/shareBatch', _arr).then((res) => {
              if (res.code == '0000') {
                bus.$emit('refreshImageList')
                this.$emit('ok')
              } else {
                this.handleSnack(res.message)
              }
            })
          }
        })
        .catch(() => {})
    },
    handleSnack(content) {
      this.snackbarData.content = content
      this.snackbarData.visible = true
    }
  }
}
</script>
<style lang="less" scoped>
span {
  display: inline-block;
  text-align: center;
  margin: 0 10px;
}

.el-button {
  color: #777;

  display: inline-block;
  vertical-align: middle;
  &.disabled {
    cursor: not-allowed;
    color: #999;
  }
  .el-icon-share {
    font-size: 18px;
  }
}
</style>
